<template>
    <div class="shop-contain-box">
      <div>
        <Trend :query="query"/>
        <Price :query="query"/>
        <Category :query="query"/>
        <NewGoods :query="query"/>
        <Brand :query="query"/>
        <LiveSales :query="query"/>
        <LiveAnchor :query="query"/>
      </div>
      <!-- <LoginOrPaySelectModule -->
        <!-- backgroundImage="https://s6.bihukankan.com/img/1216brand-trend-blur.png" -->
        <!-- propsopenVipTitle="升级为专业版年费会员，即可查看" -->
        <!-- propsopenVipStatusData="brandList" -->
        <!-- :top="0" -->
        <!-- :height="1500" -->
        <!-- translate="0,-400px" -->
        <!-- v-else -->
      <!-- /> -->
    </div>
  </template>
  
  <script>
  import Trend from "@/modules/shop/_id/sell/trend/index.vue";
  import Price from '@/modules/shop/_id/sell/price/index.vue'
  import NewGoods from "@/modules/shop/_id/sell/newGoods/index.vue";
  import Category from "@/modules/shop/_id/sell/category/index.vue";
  import Brand from "@/modules/shop/_id/sell/brand/index.vue";
  import LiveSales from "@/modules/shop/_id/sell/liveSales/index.vue";
  import LiveAnchor from "@/modules/shop/_id/sell/liveAnchor/index.vue";
  export default {
    components: { Trend,Price,NewGoods,Category,Brand,LiveSales,LiveAnchor },
    props: {
      query:{ type:Object, default: () => null },
      isVip:Boolean
    },
  };
  </script>
  
  <style lang="less" scoped>
  .shop-contain-box {
    position: relative;
    &_grid{
      margin-top: 20px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
    }
  }
  </style>